<header class="d-flex justify-content-between align-items-center" [class.hidden]="isHeaderHidden">
  <!-- Logo -->
  <div class="logo-container" (click)="goToHome()">
    <img src="assets/images/logo.svg"
         alt="Logo"
         id="logo-full"
         class="d-none d-md-block"
         [class.hidden]="isSidebarVisible">
  </div>

  <div class="d-flex justify-content-between justify-content-md-end align-items-center">

    <div class="d-flex px-2 px-md-0">
      <!-- Account -->
      <div class="account">
        @if(!isLoggedIn){
          <button mat-button class="bp-button" [routerLink]="['/login' | localize]">
            <span class="material-symbols-outlined bp-icon">login</span>
            login
          </button>

        } @else {
          <div class="account-menu">
            <button mat-button class="bp-button" [matMenuTriggerFor]="account">
              <span class="material-symbols-outlined bp-icon">account_circle</span>
              Account
            </button>

            <mat-menu #account="matMenu" id="menu-account">
              @if(userInfo?.groups?.includes('admin')){
                <button mat-menu-item [routerLink]="['/admin/products' | localize]">Admin</button>
              }
              <button mat-menu-item [routerLink]="['/user-profile' | localize]">User Profile</button>
              <button mat-menu-item (click)="logout()">Logout</button>
            </mat-menu>
          </div>

        }
      </div>

      <!-- Language Switcher -->
      <div class="language-witcher">
        <button mat-button class="bp-button" [matMenuTriggerFor]="menu">
          <span class="material-symbols-outlined bp-icon">language</span>
          @if (currentLanguage === 'en') {
            {{ 'COMMON.english' | translate }}
          } @else {
            {{ 'COMMON.german' | translate }}
          }
        </button>

        <mat-menu #menu="matMenu" id="menu-button">
          @for (lang of availableLanguages; track lang.value) {
            <button mat-menu-item (click)="switchLanguage(lang.value)">
              {{ lang.label }}
            </button>
          }
        </mat-menu>
      </div>
    </div>

    <!-- Hamburger Button -->
    <button mat-icon-button (click)="toggleSidenav()" class="d-flex">
      <mat-icon style="margin-top: -4px;">
        <span class="material-symbols-outlined">Menu</span>
      </mat-icon>
    </button>

  </div>
</header>

<div id="sidebar-overlay" (click)="toggleSidenav()" [ngClass]="{'sidebar-overlay-hidden': !isSidebarVisible}"></div>

